
import { RouteConfig } from './types';
import Dashboard from '../pages/Dashboard';
import AdminDashboard from '../pages/AdminDashboard';
import UserDashboard from '../pages/UserDashboard';
import Performance from '../pages/Performance';
import Projects from '../pages/Projects';
import Schedule from '../pages/Schedule';

export const dashboardRoutes: RouteConfig[] = [
  { 
    path: "/app/dashboard", 
    element: AdminDashboard, 
    requiresLayout: true,
    requiredRoles: ['admin']
  },
  { 
    path: "/app/home", 
    element: UserDashboard, 
    requiresLayout: true,
    requiredPermissions: ['dashboard.read']
  },
  { 
    path: "/dashboard", 
    element: Dashboard, 
    requiresLayout: true,
    requiredPermissions: ['dashboard.read']
  },
  { 
    path: "/app/performance", 
    element: Performance, 
    requiresLayout: true,
    requiredPermissions: ['performance.read']
  },
  { 
    path: "/performance", 
    element: Performance, 
    requiresLayout: true,
    requiredPermissions: ['performance.read']
  },
  { 
    path: "/app/projects", 
    element: Projects, 
    requiresLayout: true,
    requiredPermissions: ['projects.read']
  },
  { 
    path: "/projects", 
    element: Projects, 
    requiresLayout: true,
    requiredPermissions: ['projects.read']
  },
  { 
    path: "/app/schedule", 
    element: Schedule, 
    requiresLayout: true,
    requiredPermissions: ['schedule.read']
  },
  { 
    path: "/schedule", 
    element: Schedule, 
    requiresLayout: true,
    requiredPermissions: ['schedule.read']
  }
];
